import { Badge } from 'avo-ui'
import { convertStatusText, formatDateMoment, setCurrency } from 'utils/utils'
import { Link } from 'react-router-dom'
import { STATUS } from 'constants/constant'

export const SORT_ORDER = [
    {
        label: 'Sort By Order Id Desc',
        key: 'id-desc',
        name: 'sort-order',
    },
    {
        label: 'Sort By Order Id Asc',
        key: 'id-asc',
        name: 'sort-order',
    },
    {
        label: 'Sort By Date Asc',
        key: 'created_at-asc',
        name: 'sort-order',
    },
    {
        label: 'Sort By Date Desc',
        key: 'created_at-desc',
        name: 'sort-order',
    },
]

export const TABLE_ORDER = {
    name: 'Orders',
    column: [
        {
            name: 'Nomor Pesanan',
            key: 'orderId',
            render: ({ item }) => (
                <Link to={`/order/order-list/detail?orderId=${item?.id}`}>
                    <div className={'font-medium text-blue-90 hover:font-bold hover:underline'}>{item?.order_code}</div>
                </Link>
            ),
        },
        {
            name: 'Alamat Pengiriman',
            key: 'address',
            render: ({ item }) => (
                <div>
                    <div className={'font-medium'}>{item.customer_name}</div>
                    <div>{item.shipping_full_address}</div>
                </div>
            ),
        },
        {
            name: 'Ekspedisi',
            key: 'shipping',
            render: ({ item }) => (
                <div className={'flex flex-row gap-4 items-center'}>
                    <img className={'w-12'} src={item?.shipping_logo} alt='Ekspedisi' />
                    <div>
                        <div className={'font-medium'}>{item.shipping_service}</div>
                        <div>{item.shipping_destination}</div>
                    </div>
                </div>
            ),
        },
        {
            name: 'Grand Total',
            key: 'grand_total',
            render: ({ value }) => setCurrency(value),
        },
        {
            name: 'Tanggal Order',
            key: 'created_at',
            render: ({ value }) => formatDateMoment(value, 'DD/MM/YYYY HH:mm'),
        },
        {
            name: 'Status',
            key: 'status',
            render: ({ value }) => <Badge title={convertStatusText(value)} type={value} />,
        },
    ],
}

export const STATUS_ORDER = {
    semua: [
        {
            label: 'Pending Payment',
            value: STATUS.PENDING_PAYMENT,
        },
        {
            label: 'On Hold',
            value: STATUS.ON_HOLD,
        },
        {
            label: 'Processing',
            value: STATUS.PROCESSING,
        },
        {
            label: 'Packing',
            value: STATUS.PACKING,
        },
        {
            label: 'Delivery',
            value: STATUS.DELIVERY,
        },
        {
            label: 'Completed',
            value: STATUS.COMPLETED,
        },
        {
            label: 'Cancelled',
            value: STATUS.CANCELLED,
        },
    ],
    'belum dibayar': [
        {
            label: 'On Hold',
            value: STATUS.ON_HOLD,
        },
        {
            label: 'Processing',
            value: STATUS.PROCESSING,
        },
        {
            label: 'Packing',
            value: STATUS.PACKING,
        },
        {
            label: 'Delivery',
            value: STATUS.DELIVERY,
        },
        {
            label: 'Cancelled',
            value: STATUS.CANCELLED,
        },
    ],
    'on-hold': [
        {
            label: 'Processing',
            value: STATUS.PROCESSING,
        },
        {
            label: 'Packing',
            value: STATUS.PACKING,
        },
        {
            label: 'Delivery',
            value: STATUS.DELIVERY,
        },
        {
            label: 'Cancelled',
            value: STATUS.CANCELLED,
        },
    ],
    'sudah dibayar': [
        {
            label: 'Packing',
            value: STATUS.PACKING,
        },
        {
            label: 'Delivery',
            value: STATUS.DELIVERY,
        },
        {
            label: 'Completed',
            value: STATUS.COMPLETED,
        },
        {
            label: 'Cancelled',
            value: STATUS.CANCELLED,
        },
    ],
    dikemas: [
        {
            label: 'Processing',
            value: STATUS.PROCESSING,
        },
        {
            label: 'Delivery',
            value: STATUS.DELIVERY,
        },
        {
            label: 'Completed',
            value: STATUS.COMPLETED,
        },
        {
            label: 'Cancelled',
            value: STATUS.CANCELLED,
        },
    ],
    dikirim: [
        {
            label: 'Completed',
            value: STATUS.COMPLETED,
        },
        {
            label: 'Cancelled',
            value: STATUS.CANCELLED,
        },
    ],
    selesai: [
        {
            label: 'Cancelled',
            value: STATUS.CANCELLED,
        },
    ],
}

export const STATUS_ORDER_NEW = {
    [STATUS.PENDING_PAYMENT]: STATUS_ORDER['belum dibayar'],
    [STATUS.ON_HOLD]: STATUS_ORDER['on-hold'],
    [STATUS.PROCESSING]: STATUS_ORDER['sudah dibayar'],
    [STATUS.PACKING]: STATUS_ORDER['dikemas'],
    [STATUS.DELIVERY]: STATUS_ORDER['dikirim'],
    [STATUS.COMPLETED]: STATUS_ORDER['selesai'],
}

export const TAB_ORDER = ['semua', 'belum dibayar', 'sudah dibayar', 'dikemas', 'dikirim', 'selesai', 'dibatalkan']

export const TAB_ORDER_NAME = {
    'pending-payment': 'belum dibayar',
    'on-hold': 'belum dibayar',
    processing: 'sudah dibayar',
    packing: 'dikemas',
    'on-delivery': 'dikirim',
    completed: 'selesai',
    cancelled: 'dibatalkan',
}

export const INITIAL_FILTER_VALUE = {
    start_date: null,
    end_date: null,
    status: [],
    payment_services: [],
    shipping_aliases: [],
    product_ids: [],
    voucher_ids: [],
}

export const ARRAY_FILTER = ['status', 'payment_services', 'shipping_aliases']

export const ARRAY_OBJECT_FILTER = ['product_ids', 'voucher_ids']

export const DATE_FILTER = ['start_date', 'end_date']

export const ADVANCE_FILTER_OPTIONS = {
    status: [
        {
            id: 1,
            label: 'Pending Payment',
            name: 'pending-payment',
            value: 'pending-payment',
        },
        {
            id: 2,
            label: 'Belum Dibayar',
            name: 'on-hold',
            value: 'on-hold',
        },
        {
            id: 3,
            label: 'Processing',
            name: 'processing',
            value: 'processing',
        },
        {
            id: 4,
            label: 'Packing',
            name: 'packing',
            value: 'packing',
        },
        {
            id: 5,
            label: 'Delivery',
            name: 'on-delivery',
            value: 'on-delivery',
        },
        {
            id: 6,
            label: 'Completed',
            name: 'completed',
            value: 'completed',
        },
        {
            id: 7,
            label: 'Cancelled',
            name: 'cancelled',
            value: 'cancelled',
        },
    ],
}
